<template>
    <div class="area-page-wrapper">
        <div class="area-page-container">
            <div class="page-header">
                <div class="header-flex-container">
                    <button class="back-button" @click="goBack">
                        <span class="back-icon">←</span> Torna Indietro
                    </button>
                    <h2 class="page-title">Dettaglio Raccolta</h2>
                </div>
            </div>
            <!-- <div class="filter-section">
                <div class="search-container">
                    <input
                        type="text"
                        placeholder="Search..."
                        class="search-input"
                        v-model="searchTerm"
                    />
                    <div class="filter-buttons">
                        <PrimeButton
                            icon="pi pi-filter"
                            class="filter-button"
                            @click="openFilterModal"
                        />
                        <PrimeButton
                            icon="pi pi-refresh"
                            class="reset-button"
                            @click="resetFilters"
                        />
                    </div>
                </div>
            </div> -->

            <!-- Table container with explicit width and height -->
            <div class="table-container">
                <DataTable :value="entries" paginator :rows="10" dataKey="id" class="file-table"
                    v-if="!loading && entries.length > 0">
                    <Column header="ID" sortable style="min-width: 300px">
                        <template #body="slotProps">
                            <div>{{ slotProps.data.descrizione }}</div>
                        </template>
                    </Column>
                    <Column field="anno" header="Anno" sortable></Column>
                    <Column field="from" header="Da" sortable></Column>
                    <Column field="to" header="A" sortable></Column>
                    <Column header="Azioni">
                        <template #body="slotProps">
                            <Button icon="pi pi-cog" class="p-button-rounded p-button-info p-button-sm"
                                @click="manageEntry(slotProps.data.id)" />
                        </template>
                    </Column>
                    <Column header="Stato">
                        <template #body="slotProps">
                            <div class="status-badge" :class="slotProps.data.nistinc > 0 ? 'red' : 'green'">
                                {{ slotProps.data.nistinc || 0 }}
                            </div>
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, onMounted } from "vue";
import axios from "axios";
import { useRoute, useRouter } from 'vue-router';

export default {

    setup() {
        const route = useRoute();
        const router = useRouter();
        const entries = ref([]); // Usa entries per la tabella
        const searchTerm = ref("");

        const goBack = () => {
            router.back();
        };
        const fetchRDIDetail = async () => {
            try {
                console.log("Fetching with ID:", route.params.id);
                console.log("Fetching with route.query.id:", route.query.id);
                const response = await axios.post("http://127.0.0.1:8001/api/getRDIs", {
                    crd: route.params.id  // Usa il parametro route.query.id
                });
                entries.value = response.data || [];
            } catch (error) {
                console.error("Error fetching details:", error);
            }
        };

        onMounted(() => {
            fetchRDIDetail();
        });

        const openFilterModal = () => {
            console.log("Open filter modal clicked");
        };

        const resetFilters = () => {
            searchTerm.value = "";
            fetchRDIDetail();
        };

        const manageEntry = (id) => {
            router.push({ name: 'DettaglioRaccoltaIstanza', query: { id: id } });
        };

        return {
            goBack,
            entries,
            searchTerm,
            openFilterModal,
            resetFilters,
            manageEntry
        };
    }
}
</script>


<style scoped>
.area-page-wrapper {
    padding: 20px;
}

.area-page-container {
    padding: 2rem;
}

.page-header {
    margin-bottom: 1rem;
}

.header-flex-container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;
}

.back-button {
    position: absolute;
    left: 0;
    display: flex;
    align-items: center;
    padding: 8px 16px;
    background-color: #448c94;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 0.9rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3sease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.back-button:hover {
    background-color: #307a86;
}

.back-icon {
    margin-right: 8px;
}

h2.page-title {
    color: #2c3e50;
    margin: 0 auto;
}

.page-title {
    text-align: center;
    font-size: 30px;
    color: var(--text-primary) !important;
    font-weight: 600;
    padding-bottom: 10px;
    border-bottom: 2px solid var(--border-color);
}

/* Stile responsive */
@media (max-width: 768px) {
    .header-flex-container {
        flex-direction: column;
        gap: 15px;
        align-items: flex-start;
    }

    .back-button {
        position: relative;
        margin-bottom: 10px;
    }

    h2.page-title {
        width: 100%;
        text-align: center;
        margin-top: 10px;
    }
}

:deep(.p-datatable .p-sortable-column .p-sortable-column-icon) {
    color: #ffffff !important;
}

:deep(.p-datatable .p-sortable-column:not(.p-highlight):hover .p-sortable-column-icon) {
    color: #ffffff !important;
}
</style>